// extracted by mini-css-extract-plugin
export default {"cardMedia":"styles_cardMedia__LnY26","landingHoverOff":"styles_landingHoverOff__hqthf","landingHover":"styles_landingHover__TiEEw"};